import type { Session } from '@bear-auth/core';

import type { HttpError } from '@/modules/api/codegen';
import type { ErrorType } from '@/modules/api/fetcher/fetcher';
import { isExpiredShareLinkError } from '@/services/utilities/isApiError';

import { ExpiredSecretLinkAlert } from './ExpiredSecretLinkAlert';
import { NotFoundSecretAlert } from './NotFoundSecretAlert';
import { UnauthenticatedSecretAlert } from './UnauthenticatedSecretAlert';

export interface SecretDetailAlertsProps {
    authStatus: Extract<Session<unknown>['status'], 'authenticated' | 'unauthenticated'>;
    error: ErrorType<HttpError>;
}

export const SecretDetailAlerts = ({ authStatus, error }: SecretDetailAlertsProps) => {
    if (authStatus === 'unauthenticated') {
        return <UnauthenticatedSecretAlert />;
    }

    if (isExpiredShareLinkError(error)) {
        return <ExpiredSecretLinkAlert id={error.data.errorData.secretId} />;
    }

    return <NotFoundSecretAlert />;
};
